// =============================================
// FILE 2: src/components/Header.tsx
// =============================================
import React, { useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
} from '@mui/material';
import DiamondIcon from '@mui/icons-material/Diamond';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { ColorModeContext } from '@/Theme'
import { useTheme } from '@mui/material/styles';
import { ROUTES } from '@/Routes';
import { useNavigate } from 'react-router-dom';
import { logout, useAuth } from '@/firebaseApp';
import UserMenu from './ProfileMenu';

const Header: React.FC = () => {
  const colorMode = useContext(ColorModeContext);
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { user } = useAuth();
  const navigate = useNavigate();


  return (
    <AppBar position="fixed" sx={{ bgcolor: 'background.paper', boxShadow: 1, py: 1 }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Logo // TODO CREATE A BUTTON  */}
          <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1 }}>
            <DiamondIcon sx={{ fontSize: 42, color: 'primary.main' }} />
            <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: '-1px', color: theme.palette.text.primary }}>
              Route Royale
            </Typography>
          </Box>

          {/* Navigation Links */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 4, alignItems: 'center' }}>
            <Button onClick={(_) => navigate(ROUTES.HOME)} sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
              Home
            </Button>
            <Button onClick={(_) => navigate(ROUTES.SERVICES)} sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
              Services
            </Button>
            <Button onClick={(_) => navigate(ROUTES.ABOUT)} sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
              About
            </Button>
            <Button onClick={(_) => navigate(ROUTES.CONTACT)} sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
              Contact
            </Button>
            <Button onClick={(_) => navigate(ROUTES.BOOKNOW)} variant="contained" color="primary" sx={{ px: 4 }}>
              Book Now
            </Button>
          </Box>

          {/* Right side: Theme Toggle + Sign In */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton onClick={colorMode.toggleColorMode} >
              {isDark ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>

            { // photoURL, onTrips, onLogout, isDark
              user ? (

                <UserMenu
                  photoURL={user.photoURL}
                  isDark={isDark}
                  onTrips={() => navigate(ROUTES.ROUTES_USER_TRIPS)}
                  onLogout={logout}
                />

              ) : <Button
                onClick={(_) => navigate(ROUTES.SIGN_IN, {
                  state: {
                    rehydrate: false
                  }
                })}

                variant="outlined"
                sx={{
                  borderColor: theme.palette.text.primary,
                  px: 4,
                  color: theme.palette.text.primary
                }}
              >
                Sign-in
              </Button>}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;